import { jsx as _jsx } from "react/jsx-runtime";
import NotFoundPage from "@/error/NotFoundPage";
import HomePage from "@/pages/HomePage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicy";
import TermsOfServicePage from "@/pages/TermsOfService";
const routes = [
    {
        path: "/",
        element: _jsx(HomePage, {}),
    },
    {
        path: "/privacy-policy",
        element: _jsx(PrivacyPolicyPage, {}),
    },
    {
        path: "/terms-of-service",
        element: _jsx(TermsOfServicePage, {}),
    },
    // Catch-all 404 route (should be last)
    {
        path: "*",
        element: _jsx(NotFoundPage, {}),
    },
];
export default routes;
